(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["free-shipping-note"] && !Shopify.designMode) return;
  try {
    // Bepaalt client-side in welk land het apparaat van de bezoeker staat via
  // Shopify's eigen IP-detectie (/browsing_context_suggestions) en zet de
  // verzendzone als data-visitor-zone op <html>; de CSS hierboven toont dan
  // overal de juiste tarief-variant. Resultaat wordt per sessie gecachet.
  (function () {
    var note = document.querySelector('shipping-rate-note');
    if (!note || document.documentElement.hasAttribute('data-visitor-zone')) return;

    function applyCountry(country) {
      if (!country) return;
      var zone = 'other';
      if (country === note.dataset.homeCountry) {
        zone = 'home';
      } else if ((note.dataset.euCountries || '').split(',').indexOf(country) !== -1) {
        zone = 'eu';
      }
      document.documentElement.setAttribute('data-visitor-zone', zone);
    }

    var cached = null;
    try {
      cached = sessionStorage.getItem('lk-detected-country');
    } catch (error) {}
    if (cached) {
      applyCountry(cached);
      return;
    }

    fetch('/browsing_context_suggestions', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var detected = data && data.detected_values && data.detected_values.country;
        var country = detected && detected.handle ? String(detected.handle).toUpperCase() : '';
        if (country) {
          try {
            sessionStorage.setItem('lk-detected-country', country);
          } catch (error) {}
        }
        applyCountry(country);
      })
      .catch(function () {});
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-switcher"] && !Shopify.designMode) return;
  try {
    class LanguageSwitcher extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details) return;

      this.onDocumentClick = (event) => {
        if (this.details.open && !this.contains(event.target)) this.details.open = false;
      };
      this.onKeydown = (event) => {
        if (event.key !== 'Escape' || !this.details.open) return;
        this.details.open = false;
        this.querySelector('summary')?.focus();
      };

      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      this.removeEventListener('keydown', this.onKeydown);
    }
  }

  if (!customElements.get('language-switcher')) {
    customElements.define('language-switcher', LanguageSwitcher);
  }
  } catch(e) { console.error(e); }
})();

})();
